import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatCard } from '@angular/material/card';
import { BehaviorSubject } from 'rxjs';
import { GuestService } from '../../../services/guest.service';
import { Logger } from '../../../../../infrastructure/logging/logger';
import { equifaxSample } from '../../../../../../../public/assets/equifaxSample';
import { NotificationService } from '../../../../../utilities/PortalNotificationUtility';
import { GuestIdentityResultCardComponent } from './guest-detail-components/guest-identity-result-card/guest-identity-result-card.component';
import { GuestAddressResultCardComponent } from './guest-detail-components/guest-address-result-card/guest-address-result-card.component';
import { GuestDobResultCardComponent } from './guest-detail-components/guest-dob-result-card/guest-dob-result-card.component';
import { GuestPhoneResultCardComponent } from './guest-detail-components/guest-phone-result-card/guest-phone-result-card.component';
import { GuestEmailResultCardComponent } from './guest-detail-components/guest-email-result-card/guest-email-result-card.component';
import { GuestDeviceResultCardComponent } from './guest-detail-components/guest-device-result-card/guest-device-result-card.component';
import { BackButtonComponent } from '../../../../../shared/components/back-button/back-button.component';

@Component({
  selector: 'app-guest-result-detail',
  templateUrl: './guest-result-detail.component.html',
  styleUrls: ['./guest-result-detail.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinner,
    MatCard,
    RouterModule,
    GuestIdentityResultCardComponent,
    GuestAddressResultCardComponent,
    GuestDobResultCardComponent,
    GuestPhoneResultCardComponent,
    GuestEmailResultCardComponent,
    GuestDeviceResultCardComponent,
    BackButtonComponent
  ]
})
export class GuestResultDetailComponent implements OnInit {

  @Input() guest!: any;

  loading = new BehaviorSubject<boolean>(false);
  guestId!: string;
  deniedTrustArray: string[] = [];

  constructor(
    private route: ActivatedRoute,
    private guestService: GuestService,
    private notificationService: NotificationService,
    private logService: Logger
  ) { }

  ngOnInit() {
    this.loadPage();
  }

  loadPage() {
    this.loading.next(true);

    // this.route.params.subscribe(params => {
    //   this.guestId = params['id'];
    //   this.findGuestById(this.guestId);
    // });

    this.guest = equifaxSample;

    this.guest[0].details.filter((guest: any) => {
      if (guest.key.includes('Trust') && guest.value === 'N') {
        this.deniedTrustArray.push(' ' + guest.key.substring(0, guest.key.indexOf("T")).toUpperCase());
      }
    });

    this.loading.next(false);
  }

  async findGuestById(id: number) {
    this.loading.next(true);

    try {
      if (!id) {
        this.notificationService.showNotification({ message: 'Guest ID is not valid' });
        return;
      }

      this.guest = await this.guestService.getGuestDetails(id);

        // TODO: comment back in and test when we have Equifax Guest Results
        // this.guest.equifaxDetails.filter((guest: any) => {
        //   if (guest.key.includes('Trust') && guest.value === 'N') {
        //     this.deniedTrustArray.push(' ' + guest.key.substring(0, guest.key.indexOf("T")).toUpperCase());
        //   }
        // });

      if (!this.guest) {
        this.notificationService.showNotification({ message: `Guest with ID: ${id} not found` });
        return;
      }
    } catch (e) {
      this.logService.handleError(e, 'An error occurred while retrieving Guest details', `An error occurred while retrieving Guest details for ID: ${id}`);
    } finally {
      this.loading.next(false);
    }
  }

  getDecisionColor(result?: any) {
    switch (result) {
      case 'Y': 
        return 'background-green';
      case 'Approve': 
        return 'background-green';
      case 'N': 
        return 'background-red';
      case 'Deny': 
        return 'background-red';
      default: 
        return 'white';
    }
  }

}